import React from 'react';

const RenderFacets = ({facets, onClickFacet}) => {
    return (
        facets?.length !== 0 ?
            facets?.map((i) => {
                return (
                    <button
                        type="button"
                        className="search-facet"
                        key={i.value}
                        onClick={() => onClickFacet(i.value)}
                        id="button">
                                <span className={'not-crossed'}>
                                    {i.label}
                                </span>
                    </button>
                );
            }) :
            <button
                type="button"
                className="search-facet">
                        <span className={'not-crossed'}>
                            Все
                        </span>
            </button>
    );
};

export default RenderFacets;